import styled, { css } from 'styled-components';
import { Text, Icon, Button } from 'components';
import { colorVariables, mediaTemplates } from 'theme/variables';

export const SettingsListStyled = styled.div`
  &:first-child {
    padding-top: 10px;
  }
  &:last-child {
    padding-bottom: 10px;
  }
`;

export const OptionsWrap = styled.div`
  position: absolute;
  opacity: 0;
  bottom: 0;
  right: 0;
  min-width: 200px;
  width: 100%;
  background-color: ${colorVariables.gray_cod};
  visibility: hidden;
  z-index: 999;

  ${(props) =>
    props.open &&
    css`
      opacity: 1;
      visibility: visible;
    `};
`;

export const List = styled.div`
  position: relative;
  padding: 0;
  margin: 0;
  list-style-type: none;
`;

export const Header = styled.div`
  position: relative;
  height: 40px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const ItemButton = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  height: 34px;
  text-align: left;
  padding: 0 20px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  flex-grow: 1;
`;

export const ListItemButtonStyled = styled.div`
  position: relative;
  width: 100%;
  height: 34px;
  text-align: left;
  padding: 8px 20px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  flex-grow: 1;

  ${mediaTemplates.lWidth} {
    padding: 4px 20px;
  }
`;

export const StyledTextLabel = styled(Text)`
  color: white;

  &:hover {
    color: white;
  }
`;

export const StyledButton = styled(Button)`
  && {
    width: 100%;
    height: 100%;
    padding-left: 15px;
  }
`;

export const StyledItemText = styled(Text)`
  white-space: nowrap;

  ${ItemButton}:hover & {
    color: ${colorVariables.blue_ribbon};
  }
`;

export const StyledItemIcon = styled(Icon)`
  ${ItemButton}:hover & {
    color: ${colorVariables.blue_ribbon};
  }
`;
